import { IOffer } from '@rbi-ctg/menu';
import { RedemptionMethod } from 'state/offers';
import { IDays, IHours } from 'utils/offers/rule-sets/time-left-to-redeem';

export interface IAttemptOfferRedemptionArgs {
  redemptionMethod: RedemptionMethod;
  bypassCheckForAnotherOffer?: boolean;
}

export type IAttemptOfferRedemption = (args: IAttemptOfferRedemptionArgs) => void;

export type IShouldUseCustomDisclaimer = (
  isCustomDisclaimerAvailable: boolean,
  isMoreInfoDisclaimerFlagEnabled: boolean
) => boolean;

export interface IDetailsPanelViewProps {
  offer: IOffer;
  onRedeemOffer: IAttemptOfferRedemption;
  showRestaurantRedemptionButton: boolean;
  disableMobileOfferRedemptions: boolean;
  disableInRestaurantOfferRedemptions: boolean;
  redemptionErrorMessage: string | null;
  enableOfferBadges: boolean;
  endingIn: IDays | IHours | null;
  platforms: string[];
  updateDetailsPanelContentHeight: (height: number) => void;
  showMobileRedemptionButton: boolean;
  showSignUpToRedeem: boolean;
  restaurantRedemptionButtonUiType: RestaurantRedemptionButtonUiOption;
  noPossibleRedemption: boolean;
  togglePromoCodeOfferRedeemable: (offerId: string) => void;
  offerConfigLoading?: boolean;
  enableFavoriteOffers?: boolean;
  favorited?: boolean;
  favoriteLoading?: boolean;
  handleToggleFavorite?(sanityId: string, name: string): void;
}

export interface IRedemptionButtonsProps {
  onRedeemOffer: IAttemptOfferRedemption;
  showRestaurantRedemptionButton: boolean;
  disableMobileOfferRedemptions: boolean;
  disableInRestaurantOfferRedemptions: boolean;
  redemptionErrorMessage: string | null;
  showMobileRedemptionButton: boolean;
  showSignUpToRedeem: boolean;
  restaurantRedemptionButtonUiType: RestaurantRedemptionButtonUiOption;
  noPossibleRedemption: boolean;
  offerConfigLoading?: boolean;
}

export interface IRedemptionPanelProps {
  offer: IOffer;
  onRedeemOffer: IAttemptOfferRedemption;
  showRestaurantRedemptionButton: boolean;
  disableMobileOfferRedemptions: boolean;
  disableInRestaurantOfferRedemptions: boolean;
  redemptionErrorMessage: string | null;
  showMobileRedemptionButton: boolean;
  showSignUpToRedeem: boolean;
  restaurantRedemptionButtonUiType: RestaurantRedemptionButtonUiOption;
  noPossibleRedemption: boolean;
  togglePromoCodeOfferRedeemable: (offerId: string) => void;
  offerConfigLoading?: boolean;
}

export enum RestaurantRedemptionButtonUiOption {
  BUTTON = 'button',
  LINK = 'link',
}

export interface IRedemptionButton {
  onClickRestaurantRedemption: () => void;
  restaurantRedemptionButtonUiType?: RestaurantRedemptionButtonUiOption;
  restaurantRedemptionButtonTitle: string;
  disabled?: boolean;
  isDesktop?: boolean;
  isLoading?: boolean;
}

export enum RedemptionTypes {
  MOBILE_ONLY = 'mobileOnly',
  RESTAURANT_ONLY = 'restaurantOnly',
  MOBILEANDRESTAURANT = 'mobileAndRestaurant',
}
